import Layout from "../layout/Layout";
import React, {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import Button from "@amzn/awsui-components-react/polaris/button";
import Flashbar from "@amzn/awsui-components-react/polaris/flashbar"
import Spinner from "@amzn/awsui-components-react/polaris/spinner";
import {
    STATION_RECOSTING_SUMMARY_TABLE_COLUMN_DEFINITIONS,
    STATION_RECOSTING_SUMMARY_TABLE_FILTER_PROPERTIES,
    STATION_RECOSTING_SUMMARY_TABLE_VISIBLE_CONTENT_OPTIONS,
    PAGE_SIZE_OPTIONS
} from "../../utils/mapReleaseDashboard/stationRecostingSummaryTableConfig";
import ComplexFilterTable from "../offline-maps/ComplexFilterTable";
import {useMapReleaseStore} from "../../store/MapReleaseStore";
import { downloadData } from "../../utils/tableConfig";

const StationRecostingSummary = () => {
    const [searchParams] = useSearchParams();
    const mapPackSummaryId = searchParams.get("id")

    const activeValidationDataFetchStatus = false;

    const fetchStationRecostingSummary = useMapReleaseStore(
        (state) => state.fetchStationRecostingSummary
    );
    const isRecostingSummaryInvalid = useMapReleaseStore(
        (state) => state.getInvalidStationRecostingSummary()
    );
    const stationRecostingData: any[] = useMapReleaseStore(
        (state) => state.getStationRecostingData()
    );
    const isStationRecostingLoaded: boolean = useMapReleaseStore(
        (state) => state.isStationRecostingLoaded()
    );

    // Downloading Parameters
    const stationRecostingTableDownloadHeaders: string[] = useMapReleaseStore(
        (state) => state.getStationRecostingHeaders()
    );

    // Table Preferences
    const stationRecostingSummaryTablePreferences = useMapReleaseStore(
        (state) => state.stationRecostingSummaryTablePreferences
    );
    const setStationRecostingSummaryTablePreferences = useMapReleaseStore(
        (state) => state.setStationRecostingSummaryTablePreferences
    );

    type CustomFlashbarProps = {
        mapPackSummaryId: string | null;
    };
    const CustomFlashbar: React.FC<CustomFlashbarProps> = ({mapPackSummaryId}) => {
        return <Flashbar items={[
            {
                header: "Error",
                type: undefined,
                content: "Could not load station recosting summary for " + mapPackSummaryId,
                dismissible: false,
                dismissLabel: "Dismiss message",
                id: "message_1"
            }
        ]}/>;
    }

    useEffect(() => {
        if (mapPackSummaryId) {
            fetchStationRecostingSummary(mapPackSummaryId);
        }
    }, []); // Empty dependency array ensures the effect runs only once

    if (!mapPackSummaryId) {
        return <Layout> <Flashbar items={[{header: "Error", content: "Missing id parameter in the URL"}]}/> </Layout>;
    }

    return (
        <Layout>
            {isRecostingSummaryInvalid && isStationRecostingLoaded ? ([<CustomFlashbar
                    mapPackSummaryId={mapPackSummaryId}
                />, <br/>])
                : (!isStationRecostingLoaded ? ([
                        <Spinner size="large"/>,
                        <br/>, <br/>]
                ) : ([<ComplexFilterTable
                    itemList={stationRecostingData}
                    columnDefinitions={STATION_RECOSTING_SUMMARY_TABLE_COLUMN_DEFINITIONS}
                    visibleContentOptions={STATION_RECOSTING_SUMMARY_TABLE_VISIBLE_CONTENT_OPTIONS}
                    fetchingData={activeValidationDataFetchStatus}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    filterProperties={STATION_RECOSTING_SUMMARY_TABLE_FILTER_PROPERTIES}
                    preferences={stationRecostingSummaryTablePreferences}
                    setPreferences={setStationRecostingSummaryTablePreferences}
                    tableName={"Station Recosting Summary"}
                    reportLayout
                    tableDescription={
                        "Total PNF = on-zone + stem-in + stem-out. Net change = candidate − control; " +
                        "it does not count newly failing trips. A lower total can still contain " +
                        "category increases. n/a means unavailable." +
                        " Latency change = (candidate - control) / control × 100. Positive is slower; negative is faster. " +
                        "P50/P99 compare Flexible Recosting client latency on paired requests, not SPS production latency. " +
                        "Missing latency or a zero control baseline shows N/A."
                    }
                />, <br/>, <Button
                    onClick={() => downloadData(stationRecostingData, stationRecostingTableDownloadHeaders, "station_recosting_summary")}>
                    Download
                </Button>, <br/>, <br/>, <br/>]))}
            <br/>
        </Layout>
    );
};

export default StationRecostingSummary;